import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { getProjectsListV2 } from "../../api";

const useFetchProjects = (
  isCommercialDashboard,
  isPartnerships,
  isGCCProject,
  isFemtechAnalyticsProject,
  isEcosystemProject,
  isPartnershipsSandbox,
  isBizdevSandbox,
  isQuantumTechProducts,
  isHealthTechProducts,
  isLongevityProducts
) => {
  const [querySearch, setQuerySearch] = useState("");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const sectorName = useSelector((state) => state.notificationsData.sectorName);

  const dedicatedFilters = {
    isCommercialDashboard,
    isPartnerships,
    isGCCProject,
    isFemtechAnalyticsProject,
    isEcosystemProject,
    isPartnershipsSandbox,
    isBizdevSandbox,
    isQuantumTechProducts,
    isHealthTechProducts,
    isLongevityProducts,
  };

  const hasDedicatedFilter = Object.values(dedicatedFilters).some(Boolean);

  const filterKey = JSON.stringify([
    sectorName,
    isCommercialDashboard,
    isPartnerships,
    isGCCProject,
    isFemtechAnalyticsProject,
    isEcosystemProject,
    isPartnershipsSandbox,
    isBizdevSandbox,
    isQuantumTechProducts,
    isHealthTechProducts,
    isLongevityProducts,
  ]);

  useEffect(() => {
    setProjects([]);
    setPage(1);
    setHasMore(true);
  }, [filterKey]);

  useEffect(() => {
    let debounceTimeout;

    if (querySearch) {
      debounceTimeout = setTimeout(() => {
        loadProjects(1, querySearch);
      }, 2000);
    } else {
      loadProjects(page, querySearch);
    }

    return () => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
    };
  }, [querySearch, page, filterKey]);

  const loadProjects = (page, querySearch) => {
    setLoading(true);

    const query = {
      page,
      querySearch,
      sector: hasDedicatedFilter ? "All Projects" : sectorName,
      platform: window.location.origin,
    };

    Object.entries(dedicatedFilters).forEach(([key, value]) => {
      if (value === true) {
        query[key] = true;
      }
    });

    getProjectsListV2(query)
      .then(({ data }) => {
        if (data?.projects?.docs?.length) {
          const newProjects = data.projects.docs;
          setProjects((prev) => [...new Set([...prev, ...newProjects])]);
          setHasMore(data.projects.hasNextPage);
        } else {
          if (page === 1) {
            setProjects([]);
          }
          setHasMore(false);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 404 && page === 1) {
          setProjects([]);
          setHasMore(false);
          return;
        }
        message.error("Something went wrong, Please try again !!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const searchFilter = (e) => {
    setProjects([]);
    setQuerySearch(e.target.value);
    setPage(1);
  };

  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return {
    projects,
    loading,
    hasMore,
    searchFilter,
    fetchMoreData,
    querySearch
  };
};

export default useFetchProjects;
